import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Box } from '@material-ui/core';
import CaseActivityInfo from '@components/CaseActivityDrawer/presentationalComponents/CaseActivityInfo/CaseActivityInfo';
import { CaseActivityGridFields } from '@components/CaseActivityDrawer/presentationalComponents/CaseActivityContainer/CaseActivityContainer.types';
import { useSsmUiFlags } from '@utilities/hooks/useSsmUiFlags/useSsmUiFlags';

const useStyles = makeStyles(() => ({
	pendingCancellationInfo: {
		gridArea: `${CaseActivityGridFields.REASON}`,
		display: 'flex',
		flexDirection: 'column',
	},
}));

interface PendingCancellationInfoProps {
	ssmCancellationReason?: string;
	intendToReschedule?: boolean | null;
	message?: string | null;
}

export const PendingCancellationInfo: React.FC<PendingCancellationInfoProps> = ({
	ssmCancellationReason,
	intendToReschedule,
	message,
}) => {
	const classes = useStyles();
	const { wCancellationReasonOptions } = useSsmUiFlags();
	const hasCancellationOptionsEnabled = Boolean(wCancellationReasonOptions?.length);

	if (!hasCancellationOptionsEnabled) {
		return (
			<Box className={classes.pendingCancellationInfo}>
				{message && (
					<CaseActivityInfo label="Details:" data-field="caseDetails-caseActivity-message">
						{message}
					</CaseActivityInfo>
				)}
			</Box>
		);
	}

	return (
		<Box className={classes.pendingCancellationInfo}>
			{ssmCancellationReason && (
				<CaseActivityInfo
					data-field="caseDetails-caseActivity-ssmCancellationReason"
					label="Cancel Reason:"
				>
					{ssmCancellationReason}
				</CaseActivityInfo>
			)}
			{intendToReschedule !== null && intendToReschedule !== undefined && (
				<CaseActivityInfo
					data-field="caseDetails-caseActivity-intendToReschedule"
					label="Planning to Reschedule:"
				>
					{intendToReschedule ? 'Yes' : 'No'}
				</CaseActivityInfo>
			)}
			{message && (
				<CaseActivityInfo label="Details:" data-field="caseDetails-caseActivity-message">
					{message}
				</CaseActivityInfo>
			)}
		</Box>
	);
};

